import axios from "axios";
const sendReview = (rate, review, d_cnic, id) => {
	const rateint = parseInt(rate);
	console.log(rate, review, d_cnic, id);
	return new Promise((resolve, reject) => {
		const token = localStorage.getItem("token");

		const req = {
			rating: rateint,
			review: review,
			token: token,
			d_cnic: d_cnic,
			appointment_id: id,
		};
		const jsonReq = JSON.stringify(req);
		axios
			.post(`/api/v1/patient/review`, jsonReq, {
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then((res) => {
				console.log(res);
				console.log("Success");
				resolve(res);
			})
			.catch((err) => {
				console.log(err);
				reject(err);
			});
	});
};

const sendReport = (report, d_cnic) => {
	return new Promise((resolve, reject) => {
		const token = localStorage.getItem("token");
		const role = localStorage.getItem("role");
		let req = {}

		 if (role == "patient"){
			req = {
			report: report,
			token: token,
			d_cnic: d_cnic,
			}
			
		}
		else if (role == "doctor")
		{
			req = {
				report: report,
				token: token,
				patient_phone: d_cnic,
				}
		};
		const jsonReq = JSON.stringify(req);
		axios
			.post(`/api/v1/${role}/report`, jsonReq, {
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then((res) => {
				console.log(res);
				console.log("Success");
				resolve(res);
			})
			.catch((err) => {
				console.log(err);
				reject(err);
			});
	});
};

export { sendReview, sendReport };
